import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { SessionService } from  '../../../services/session.service';
import { ApiService } from '../../../services/api.service';
import { CreateModalComponent } from './create-modal/create-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../../services/navigation.service';
import { DashboardService } from '../../../services/dashboard.service';
import { AdminLayoutService } from '../admin-layout.service';
import moment from 'moment';
@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {
  clientLogo: any;
  newColor: any;
  menuTabs:any = ['generalMenuTab', 'filterMenuTab'];
  colDefs: ColDef<any>[] = [];
  getUserType:any = [];
  rowData: any = [];
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    wrapText: true,
    wrapHeaderText: true,
    autoHeight:true,
    autoHeaderHeight: true,
    resizable: true,
    sortable: true,
    filter: true
  };
  public themeClass: string = "ag-theme-quartz";
  reqSubcription: Subscription[] = [];
  clientKey:any;
  moduleName:any;
  moduleKey:any;
  loader=false;
  error_name:any;

  constructor(
    private sessionService: SessionService,
    private dialog: MatDialog,
    private router: ActivatedRoute,
    private dashboardService: DashboardService,
    private navigationService: NavigationService,
    private adminLayoutService: AdminLayoutService,
  ) { 
    this.router.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';

      this.router.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];

        this.dashboardService.moduleKey = this.moduleKey;
      })

    })
  }

  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();
    this.getUserTypes()
    this.loadApiData()


    this.colDefs = [
      { 
        field: "usr_email_id", 
        headerName: "Email", 
        cellClass: 'cell-wrap-text', 
        minWidth: 250, 
        autoHeight: true,
        menuTabs: this.menuTabs,
        cellStyle: { 'white-space': 'normal' }
      },
      { 
        field: "usr_fst_nm", 
        headerName: "First Name", 
        cellClass: 'cell-wrap-text',
        menuTabs: this.menuTabs,
        autoHeight: true
      },
      { 
        field: "usr_lst_nm", 
        headerName: "Last Name", 
        cellClass: 'cell-wrap-text',
        menuTabs: this.menuTabs,
        autoHeight: true
      },
      { 
        field: "usr_display_nm", 
        headerName: "Display Name", 
        cellClass: 'cell-wrap-text',
        menuTabs: this.menuTabs,
        autoHeight: true
      },
      { 
        field: "gender", 
        headerName: "Gender", 
        cellClass: ['cell-wrap-text', 'user-management-grid-ag-center-cell'],
        headerClass: 'user-management-grid-center-header',
        autoHeight: true,
        menuTabs: this.menuTabs
      },
      { 
        field: "user_type_id", 
        headerName: "User Type", 
        cellClass: 'cell-wrap-text',
        autoHeight: true,
        menuTabs: this.menuTabs,
        valueFormatter: (params) => this.getUserType.find((f:any) => f.USER_TYPE_ID == params.value)?.USER_TYPE_NM || params.value
      },
      { 
        field: "start_date", 
        headerName: "Start Date", 
        cellClass: 'cell-wrap-text',
        menuTabs: this.menuTabs,
        valueFormatter: (params) => params.value ? moment(params.value).format("MM/DD/YYYY") : params.value
      },
      { 
        field: "end_date", 
        headerName: "End Date", 
        cellClass: 'cell-wrap-text',
        menuTabs: this.menuTabs,
        valueFormatter: (params) => params.value ? moment(params.value).format("MM/DD/YYYY") : params.value
      },
      {
          headerName: 'Actions',
          suppressMenu: true,
          cellClass: ['cell-wrap-text', 'user-management-grid-ag-center-cell'],
          headerClass: 'user-management-grid-center-header',
          cellRenderer: (params:any) => {
            if(params.data.qtr_end_dt) return '';
            return `
              <button id="edit" style="cursor:pointer;background: none;border: none;">
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.75 12.1641H12.75" stroke="#1363DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.75 1.16421C10.0152 0.898997 10.3749 0.75 10.75 0.75C10.9357 0.75 11.1196 0.78658 11.2912 0.857651C11.4628 0.928721 11.6187 1.03289 11.75 1.16421C11.8813 1.29554 11.9855 1.45144 12.0566 1.62302C12.1276 1.7946 12.1642 1.9785 12.1642 2.16421C12.1642 2.34993 12.1276 2.53383 12.0566 2.70541C11.9855 2.87699 11.8813 3.03289 11.75 3.16421L3.41667 11.4975L0.75 12.1642L1.41667 9.49755L9.75 1.16421Z" stroke="#1363DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              `
              // <button id="delete" style="cursor:pointer;background: none;border: none;">
              //   <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              //     <path d="M0.75 3.41602H2.08333H12.75" stroke="#D11044" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              //     <path d="M11.4173 3.41667V12.75C11.4173 13.1036 11.2768 13.4428 11.0268 13.6928C10.7767 13.9429 10.4376 14.0833 10.084 14.0833H3.41732C3.0637 14.0833 2.72456 13.9429 2.47451 13.6928C2.22446 13.4428 2.08398 13.1036 2.08398 12.75V3.41667M4.08398 3.41667V2.08333C4.08398 1.72971 4.22446 1.39057 4.47451 1.14052C4.72456 0.890476 5.0637 0.75 5.41732 0.75H8.08398C8.43761 0.75 8.77674 0.890476 9.02679 1.14052C9.27684 1.39057 9.41732 1.72971 9.41732 2.08333V3.41667" stroke="#D11044" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              //     <path d="M5.41602 6.75V10.75" stroke="#D11044" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              //     <path d="M8.08398 6.75V10.75" stroke="#D11044" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              //   </svg>
              // </button>
          } 
          ,
          onCellClicked: (params: any) => {

            const target = params.event.target as HTMLElement;

            // Check if the user clicked the Edit button or its SVG children
            if (target.closest('#edit')) {
              this.editRow(params.data);
            }

            // Check if the user clicked the Delete button or its SVG children
            if (target.closest('#delete')) {
              this.confirmationPopup(params.data);
            }

          },
        }
    ]
  }

  openModel(data?:any) {
    let dialogRef = this.dialog.open(CreateModalComponent, {
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: {
        getUserType: this.getUserType,
        rowData: data ? data : ''
      }
    });

    dialogRef.afterClosed().subscribe((value) => {
      if(value=='submit') {
        this.loadApiData()
      }
    });
  }

  loadApiData() {
    let body = {
      client_key: this.clientKey,
      module_key: this.moduleKey,
    };

    this.loader = false;
    this.reqSubcription.push(
      this.adminLayoutService.getUserList(body).subscribe((res:any)=> {
        this.loader = true;
        
        this.rowData = res == null ? [] : res;
        this.rowData = this.rowData.filter((f:any) => f.user_type_id == 1003);
        if(this.rowData.length==0) {
          this.error_name = 'There is no data for this time period';
        } else {
          this.error_name = '';
        }
      },(err:any)=>{
        this.loader = true;
        this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
      })
    )
  }

  getUserTypes() {
    this.reqSubcription.push(
      this.adminLayoutService.getUserTypes().subscribe((res:any) => {
        this.getUserType = res == null ? [] : res;
      }, err => {
        this.getUserType = [];
      })
    )
  }

  editRow(data:any) {
    // debugger
    this.openModel(data);
  }

  confirmationPopup(data:any) {
    debugger
  }
 
}
